import scrollIt from './scrollit';

class FilterAndSearch {
  constructor() {
    this.opened = false;
    this.originalPosition = null;
    this.trigger = [...document.querySelectorAll('.js-searchForm-mTrigger')];

    if (this.trigger.length) {
      this.bindEvents();
    }
  }

  toggle() {
    if (this.opened !== false) {
      document.documentElement.classList.remove('hdr-searchbar-open');
      if (this.originalPosition) {
        scrollIt(this.originalPosition);
        this.originalPosition = null;
      }
      this.opened = false;
    } else {
      this.originalPosition = window.scrollY;
      document.documentElement.classList.add('hdr-searchbar-open');
      this.opened = true;
    }
  }

  bindEvents() {
    this.trigger.map(btn => {
      btn.addEventListener('click', event => {
        event.preventDefault();
        this.toggle();
      });
    });
  }
}

export default new FilterAndSearch();



// WEBPACK FOOTER //
// ./src/js/filter-and-search.js